import { ArrowRight, ArrowUpRight } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { PRODUCTS } from "@/contexts/CartContext";
import { LocalizedLink } from "@/components/LocalizedLink";
import { PlatformOrbit } from "@/components/field/PlatformOrbit";
import { useHomeHeroMotion } from "@/components/field/useHomeHeroMotion";
import { productPath } from "@/lib/scaleModels";
import scaleImage from "@/assets/products/studio/scale-4g.webp?w=400&format=webp";
import scaleImageSet from "@/assets/products/studio/scale-4g.webp?w=200;400;600&format=webp&as=srcset";
import "@/styles/home-hero.css";

export const HomeHero = () => {
  const { t } = useLanguage();
  const productsRef = useHomeHeroMotion();

  return (
    <section className="field-wrap home-hero" aria-labelledby="home-hero-title">
      <div className="home-hero-copy">
        <p className="field-label field-page-label">
          {t("field.home.eyebrow")}
        </p>
        <h1 className="field-title field-page-title" id="home-hero-title">
          {t("field.home.title")}{" "}
          <em>{t("field.home.titleAccent")}</em>
        </h1>
        <p className="home-hero-lead">{t("field.home.intro")}</p>
        <div className="home-hero-actions">
          <LocalizedLink to="/platform" className="field-button">
            {t("field.home.simple.appCta")}
            <ArrowRight size={18} aria-hidden="true" />
          </LocalizedLink>
          <LocalizedLink to="/products" className="field-button field-button-secondary">
            {t("field.home.simple.shopCta")}
            <ArrowUpRight size={18} aria-hidden="true" />
          </LocalizedLink>
        </div>
      </div>

      <div className="home-hero-visual">
        <ul ref={productsRef} id="devices" className="home-hero-products" aria-label={t("field.home.products.label")}>
          <li className="home-hero-product home-hero-product--platform">
            <LocalizedLink to="/platform" className="home-hero-product-link">
              <div className="home-hero-product-top">
                <h2 className="home-hero-product-name">{t("field.home.products.app.name")}</h2>
                <ArrowUpRight size={18} strokeWidth={1.5} aria-hidden="true" />
              </div>
              <div className="home-hero-product-media home-hero-platform-media">
                <PlatformOrbit size="tile" />
              </div>
              <p className="home-hero-product-description">{t("field.home.products.app.description")}</p>
            </LocalizedLink>
          </li>
          <li className="home-hero-product home-hero-product--scale">
            <LocalizedLink to={productPath("Scale4G")} className="home-hero-product-link">
              <ArrowUpRight className="home-hero-product-arrow" size={15} strokeWidth={1.5} aria-hidden="true" />
              <div className="home-hero-product-top">
                <h2 className="home-hero-product-name">{t("field.home.products.Scale4G.name")}</h2>
                {PRODUCTS.some((item) => item.id === "Scale4G" && !item.inStock && item.restocking) && (
                  <span className="home-hero-product-status">{t("field.home.products.Scale4G.status")}</span>
                )}
              </div>
              <div className="home-hero-product-media">
                <img
                  src={scaleImage}
                  srcSet={scaleImageSet}
                  sizes="(max-width: 560px) 42vw, (max-width: 767px) 220px, (max-width: 1100px) 280px, 230px"
                  alt={t("field.shop.imageAlt.Scale4G")}
                  width={1200}
                  height={900}
                  loading="eager"
                  decoding="async"
                />
              </div>
              <p className="home-hero-product-description">{t("field.home.products.Scale4G.description")}</p>
            </LocalizedLink>
          </li>
        </ul>
      </div>
    </section>
  );
};
